"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Toggle = _interopRequireDefault(require("../Toggle"));

// Libraries
// Components
var Hover = function Hover(_ref) {
  var children = _ref.children;
  return _react["default"].createElement(_Toggle["default"], null, function (_ref2) {
    var isOpen = _ref2.isOpen,
        handleOpen = _ref2.handleOpen,
        handleClose = _ref2.handleClose;
    return _react["default"].createElement("div", {
      onMouseEnter: handleOpen,
      onMouseLeave: handleClose
    }, children({
      isHovered: isOpen
    }));
  });
};

var _default = Hover;
exports["default"] = _default;